import React from 'react';
import Container from 'react-bootstrap/Container';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import StepsCard from '@/components/howitworkspage/StepsCard';

const images = ['/svgs/step4b.svg', '/svgs/step1b.svg', '/svgs/step3b.svg', '/svgs/step2b.svg', '/svgs/step5b.svg', '/svgs/step6b.svg'];
function ForMinisSection() {
  return (
    <div className="site-section">
      <Container fluid="md">
        <Row>
          <Col>
            <h3 id="MiniSection">For Minis</h3>
            <br />
          </Col>
        </Row>
        <Row>
          <StepsCard
            image={images[0]}
            stepNumber="01"
            content={
                            "To protect the safety and privacy of you and our Big’s we’ll verify the information you entered on your form. After you’re verified, we'll send you an email welcoming you to the program and providing instructions about the basics of training, how to change your availability, request a match, and update your contact information. You’ll need to log in to the Big & Mini site to access your training."
                        }
          />
          <StepsCard
            image={images[1]}
            stepNumber="02"
            content="On your dashboard, there will be a link to training. You’ll need to read through the document and fill out the associated form to confirm that you understood and completed the training. When you’re done, we will review your application."
          />
          <StepsCard
            image={images[2]}
            stepNumber="03"
            content="Congratulations! If you make it to this step, it means you have been selected to be a Mini! Based on your availability and interests, we’ll automatically match you with a Big (don’t worry, they won’t get any personal details besides your first name and any common interests). Once you get a match, you’ll get an email telling you to log in to the Big & Mini dashboard. On your dashboard, your match information (name of Big, time of meeting, meeting link, common interests) will be displayed."
          />
          <StepsCard
            image={images[3]}
            stepNumber="04"
            content="If you can make the match time and date described on the dashboard, go ahead and click the confirm button to let your Big know! If not, send us a quick email at contact@bigandmini.org and we’ll coordinate with your Big to find you another time. Once they confirm a time, we’ll send you an email saying your dashboard has been updated. You’ll need to log in and hit the confirm button to cement your match."
          />
          <StepsCard
            image={images[4]}
            stepNumber="05"
            content="On the day of the match, you’ll receive a reminder email. When the time of your meeting comes, you’ll need to log in to your dashboard and click the meeting link to be redirected to the video call platform. FInally, you’ll get to meet your Big!"
          />
          <StepsCard
            image={images[5]}
            stepNumber="06"
            content="Following each match, you’ll have the opportunity to rate the quality of your call and provide feedback. Your match will automatically be scheduled for the same time and day the following week, and you’ll use the same procedure to reschedule and confirm your match. If you want a new match, click the switch match button and you’ll be reentered into the match pool."
            subContent={(
              <div>
                <br />
                <a href="signup" className="nice-yellow-button">Sign Up</a>
              </div>
                          )}
          />

        </Row>
      </Container>
    </div>
  );
}

export default ForMinisSection;
